import cn from 'classnames';
import { useState } from 'react';
import Drawer from '@packages/shared/core/common/components/common/Drawer';
import RenderOnlyOnClient from '@packages/shared/core/common/components/common/RenderOnlyOnClient';
import { useRedirectToMainApp } from '@packages/shared/core/common/hooks';
import Icon from '@packages/shared/svg-sprites/ui/atoms/Icon';
import { IsFeatureOn } from '@packages/shared/core/feature-flags/ui';
import {
  consentSettingsAvailableAsknebulaFeatureName,
  impressumAvailableAsknebulaFeatureName,
} from '@packages/shared/core/feature-flags/config';
import { useCookieConsent } from '@packages/shared/core/cookie-consent/hooks';
import styles from './HeaderMenu.module.scss';

type HeaderMenuProps = {
  className?: string;
};

export const HeaderMenu = ({ className }: HeaderMenuProps) => {
  const [isOpened, setIsOpened] = useState(false);

  const {
    getTermsPagePath,
    getFAQPagePath,
    getSupportPath,
    getCookiePolicyPagePath,
    getPrivacyPagePath,
    getMoneyBackPolicyPagePath,
    getFullDisclaimerPagePath,
    getImpressumPagePath,
    getLegalCenterPagePath,
  } = useRedirectToMainApp();

  const { openConsentSettings, consentSettingsButtonText } = useCookieConsent();

  const onControlClick = () => {
    setIsOpened((value) => !value);
  };

  const onClose = () => {
    setIsOpened(false);
  };

  return (
    <div className={cn(styles.root, className)}>
      <span className={styles.menuControl} onClick={onControlClick}>
        <Icon name="burger" className={styles.menuControlIcon} />
      </span>

      <Drawer
        open={isOpened}
        onClose={onClose}
        PaperProps={{ className: styles.menuContentWrapper }}
        className={styles.drawerRoot}
      >
        <div className={styles.menuContent}>
          <div className={styles.menuCloseWrapper}>
            {/* TODO change to button */}
            <span className={styles.menuClose} onClick={onClose}>
              <Icon name="cross" className={styles.menuCloseIcon} />
            </span>
          </div>

          <nav className={styles.menuNav}>
            <ul className={styles.menuNavList}>
              <li className={styles.menuNavListItem}>
                <a className={styles.menuNavLink} href={getTermsPagePath()}>
                  Terms of Use
                </a>
              </li>

              <li className={styles.menuNavListItem}>
                <a className={styles.menuNavLink} href={getPrivacyPagePath()}>
                  Privacy Policy
                </a>
              </li>

              <li className={styles.menuNavListItem}>
                <a className={styles.menuNavLink} href={getFullDisclaimerPagePath()}>
                  Full Disclaimer
                </a>
              </li>

              <RenderOnlyOnClient>
                <IsFeatureOn name={impressumAvailableAsknebulaFeatureName}>
                  <li className={styles.menuNavListItem}>
                    <a className={styles.menuNavLink} href={getImpressumPagePath()}>
                      Impressum
                    </a>
                  </li>
                </IsFeatureOn>
              </RenderOnlyOnClient>

              <li className={styles.menuNavListItem}>
                <a className={styles.menuNavLink} href={getLegalCenterPagePath()}>
                  Legal center
                </a>
              </li>

              <li className={styles.menuNavListItem}>
                <a className={styles.menuNavLink} href={getCookiePolicyPagePath()}>
                  Cookie Policy
                </a>
              </li>

              <li className={styles.menuNavListItem}>
                <a className={styles.menuNavLink} href={getMoneyBackPolicyPagePath()}>
                  Money Back Policy
                </a>
              </li>

              <li className={styles.menuNavListItem}>
                <a className={styles.menuNavLink} href={getFAQPagePath()}>
                  FAQ
                </a>
              </li>

              <li className={styles.menuNavListItem}>
                <a className={styles.menuNavLink} href={getSupportPath()}>
                  Contact Us
                </a>
              </li>

              <RenderOnlyOnClient>
                <IsFeatureOn name={consentSettingsAvailableAsknebulaFeatureName}>
                  <li className={styles.menuNavListItem}>
                    <button type="button" className={styles.menuNavLink} onClick={openConsentSettings}>
                      {consentSettingsButtonText}
                    </button>
                  </li>
                </IsFeatureOn>
              </RenderOnlyOnClient>
            </ul>
          </nav>
        </div>
      </Drawer>
    </div>
  );
};

export default HeaderMenu;
